export default __webpack_public_path__ + "static/media/dataLog.04164726.svg";